module.exports = __webpack_public_path__ + "static/media/trash.eb624c41.svg";